import React from 'react'

const HomeBanner = () => {
  return (
    <>
      <section className="overflow-hidden">
        <div className="our-agencies">
          <div className="deco-block">
            <div className="row">
              <div className="col-sm-7 col-12">
                <div className="text-pro">
                  <div className="address">
                    <div className="title text-uppercase">
                      Professionnel ou particulier,
                      <br />
                      profitez de notre service de
                      <br />
                      création de devis en 1 clic et
                      <br />
                      trouvez facilement tous les
                      <br />
                      produits dont vous avez
                      <br />
                      besoin <br />
                    </div>
                    <div className="text">
                      Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed
                      diam nonummy <br />
                      nibh euismod tincidunt ut laoreet dolore magna aliquam erat
                      volutpat. Ut wisi <br />
                      enim ad minim veniam, quis nostrud exerci tation ullamcorper
                      suscipit lobortis <br />
                      nisl ut aliquip ex ea commodo consequat. Duis autem vel eum
                      iriure dolor in <br />
                      hendrerit in vulputate velit esse molestie consequat, vel illum
                      dolore <br />
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-sm-5 col-12">
                <div className="outdoor">
                  <img
                    src="/assets/images/Outdoor-wood-deck.png"
                    width="100%"
                    alt=""
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

export default HomeBanner